import React, {useEffect, useRef, useState} from 'react'
import Media from 'react-media'
import size from 'lodash/size'
import './style.scss'
import CardContainer from '../cardContainer'
import ChooseDropdown from '../chooseDropdown'
import Hint from '../hint'
import {
  getTableCardsCount,
} from '../../helpers/common'
import bem from '../../helpers/bem'
import {
  MENU_CARDS_LEFT_MORE,
  MENU_CARDS_LEFT_PICK, MENU_CARDS_PLAYER_LEFT_NOCOMMUNITY,
  MENU_CHOOSE_LEFT_CARD,
  MENU_CHOOSE_LEFT_CARDS,
  MENU_CHOOSE_TITLE,
  MENU_ERROR_HINT_TITLE,
  MENU_GET_RESULTS_BUTTON,
  MENU_GET_RESULTS_BUTTON_POC,
  MENU_HELP_HINT_INFO,
  MENU_HELP_HINT_INFO_POC,
  MENU_HELP_HINT_LIST,
  MENU_HELP_HINT_LIST_POC,
  MENU_HELP_HINT_TITLE,
  MENU_HELP_HINT_TITLE_POC,
  MENU_LOGO_TEXT,
  MENU_LOGO_TEXT_POC,
  MENU_MOBILE_CHOOSE_BUTTON,
  MENU_RESET_BUTTON,
  MENU_SUBTITLE,
  MENU_TITLE,
} from '../../constants/translations'
import ButtonsWrapper from '../buttonsWrapper'
import Card from '../card'
import {usePrevious} from '../../hooks/common'
import {resize} from '../../constants/events'
import {
  TYPE_BUTTON_CLOSE,
  TYPE_HINT_ERROR,
  TYPE_HINT_HELP,
  TYPE_PLAYER,
  TYPE_TABLE,
} from '../../constants/types'
import {
  FLOP_TYPE,
  RIVER_TYPE,
  TURN_TYPE,
} from '../../constants/board'
import {
  BUTTON_TYPE_BLUE,
  BUTTON_TYPE_GREY,
} from '../../constants/buttonTypes'
import {getCardKey} from '../../helpers/card'
import {
  MAX_WIDTH_834,
  MIN_WIDTH_835,
} from '../../constants/mediaQueries'

const Menu = (props) => {
  const {
    menu,
    addCardToBoard,
    updateActiveField,
    hints,
    toggleHint,
    closeHint,
    showHint,
    reset,
    calculateOdds,
    getWinnerHand,
    settingsRules,
    settingsPlayers,
    setPlayersCount,
    setRules,
    activeFieldType,
    activeFieldId,
    activeFieldCardId,
    activeFieldCardType,
    players,
    table,
    setChosenCard,
    removeCard,
    isPOC,
    currentFieldInfo,
    setCardsMenu,
    cardsMenu,
    everythingChosen,
    cardsLeftToPick,
    errorInfo,
    isMobile,
    noCommunityCards,
  } = props;
  const block = 'menu';
  const chooseTopBlock = useRef(null);
  const prevEverythingChosen = usePrevious(everythingChosen);

  const setRulesOption = (id) => {
    setRules(id);
    reset();
  };

  const updateTopBlockHeight = () => {
    const topBlockHeight = chooseTopBlock.current
      && chooseTopBlock.current.offsetHeight;
    setChooseTopBlockHeight(topBlockHeight);
  };

  useEffect(() => {
    if (everythingChosen && everythingChosen !== prevEverythingChosen) {
      setTimeout(() => setCardsMenu(false), 500);
    }
  });

  const [chooseTopBlockHeight, setChooseTopBlockHeight] = useState(null);
  const mainChooseBlockStyle = {
    top: chooseTopBlockHeight + 'px',
    height: `calc(100% - ${chooseTopBlockHeight + 'px'})`,
  };

  useEffect(() => {
    window.addEventListener(resize, updateTopBlockHeight);
    return () => window.removeEventListener(resize, updateTopBlockHeight);
  }, []);

  useEffect(() => {
    updateTopBlockHeight();
  });

  const getMenuCardsMods = () => {
    return {
      'visible': !!cardsMenu,
    }
  };

  const getPlayerCardsMods = () => {
    return {
      ['count-' + players[0].hand.length]: !!players
    }
  };

  const getTableCardsMods = () => {
    return {
      ['count-' + getTableCardsCount(table)]: !!table
    }
  };

  const chosenPlayerBlock = () => {
    const player = players.find((player, index) => {
      return (activeFieldType && (index === activeFieldId))
        || (activeFieldType !== TYPE_PLAYER
          && !size(table)
          && (player.id === players.length));
    });
    return player && player.hand.map((card, index) =>
      <Card
        rank={card && card.rank}
        suit={card && card.suit}
        key={getCardKey(index, card)}
        playerId={player.id}
        handId={index}
        chosen={activeFieldCardId === index}
        menuState
        removeCard={removeCard}
        setChosenCard={setChosenCard}
      />
    )
  };

  return (
    <div className={block}>
      <Media
        query={MIN_WIDTH_835}
        render={() => (
          <div className={bem({block, elem: 'header'})}>
            <div className={bem({block, elem: 'logo'})}>
            </div>
            {isPOC ? MENU_LOGO_TEXT_POC : MENU_LOGO_TEXT}
          </div>
        )}
      />
      <div className={bem({block, elem: 'choose-wrapper'})}>
        <div className={bem({block, elem: 'choose-block'})}>
          <Media query={MAX_WIDTH_834}>
            {matches => matches ? (
              <div className={bem({block, elem: 'choose-items'})}>
                <ChooseDropdown
                  options={settingsRules}
                  setOption={setRulesOption}
                  game
                />
                <ChooseDropdown
                  options={settingsPlayers}
                  setOption={setPlayersCount}
                  players
                />
              </div>
            ) : (
              <React.Fragment>
                <div className={bem({block, elem: 'choose-title'})}>
                  {MENU_TITLE}
                </div>
                <div className={bem({block, elem: 'choose-subtitle'})}>
                  {MENU_SUBTITLE}
                </div>
              </React.Fragment>
            )}
          </Media>
        </div>
        <div
          className={bem({block, elem: 'choose-hint-button'})}
          onClick={() => toggleHint(TYPE_HINT_HELP)}
        />
      </div>
      <Media query={MAX_WIDTH_834}>
        {matches => matches ? (
          <div className={bem({block, elem: 'choose-items-block'})}>
            <div
              className={bem({block, elem: 'choose-button'})}
              onClick={() => setCardsMenu(true)}
            >
              {MENU_MOBILE_CHOOSE_BUTTON}
            </div>
          </div>
        ) : (
          <div className={bem({block, elem: 'choose-items'})}>
            <ChooseDropdown
              options={settingsRules}
              setOption={setRulesOption}
              game
            />
            <ChooseDropdown
              options={settingsPlayers}
              setOption={setPlayersCount}
              players
            />
          </div>
        )}
      </Media>
      <div className={bem({block, elem: 'help-hint'})}>
        <Hint
          title={isPOC ? MENU_HELP_HINT_TITLE_POC : MENU_HELP_HINT_TITLE}
          info={isPOC ? MENU_HELP_HINT_INFO_POC : MENU_HELP_HINT_INFO}
          list={isPOC ? MENU_HELP_HINT_LIST_POC : MENU_HELP_HINT_LIST}
          hints={hints}
          type={TYPE_HINT_HELP}
          show={showHint}
          close={closeHint}
        />
      </div>
      <div className={bem({block, elem: 'cards', mods: getMenuCardsMods()})}>
        <div className={bem({block, elem: 'cards-wrapper'})}>
          {isMobile && (
            <div
              ref={chooseTopBlock}
              className={bem({block, elem: 'choose-top-block'})}
            >
              <div className={bem({block, elem: 'choose-cards'})}>
                <div>
                  <div className={bem({block, elem: 'choose-cards-title'})}>
                    {MENU_CHOOSE_TITLE}
                  </div>
                  <div className={bem({block, elem: 'choose-cards-subtitle'})}>
                    {currentFieldInfo}
                    {activeFieldType === TYPE_PLAYER && (
                      <React.Fragment>
                        {noCommunityCards && MENU_CARDS_PLAYER_LEFT_NOCOMMUNITY}
                        {!noCommunityCards && (
                          <React.Fragment>
                    <span>
                          {cardsLeftToPick}
                      {MENU_CARDS_LEFT_MORE}
                      {cardsLeftToPick === 1
                        ? MENU_CHOOSE_LEFT_CARD
                        : MENU_CHOOSE_LEFT_CARDS}
                        </span>
                            {MENU_CARDS_LEFT_PICK}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                </div>
                <ButtonsWrapper
                  click={() => setCardsMenu(false)}
                  type={TYPE_BUTTON_CLOSE}
                />
              </div>
              <React.Fragment>
                {(activeFieldType === TYPE_PLAYER || !size(table)) && (
                  <div className={bem({
                    block,
                    elem: 'player-cards',
                    mods: getPlayerCardsMods()
                  })}>
                    {chosenPlayerBlock()}
                  </div>
                )}
                {((activeFieldType === TYPE_TABLE && table)
                  || (!activeFieldType && size(table) > 0)) && (
                  <div className={bem({block, elem: 'table-cards', mods: getTableCardsMods()})}>
                    {table.flop && table.flop.map((card, index) => {
                      return <Card
                        key={card + index}
                        handId={index}
                        rank={card.rank}
                        suit={card.suit}
                        chosen={(activeFieldCardType === FLOP_TYPE) && (activeFieldCardId === index)}
                        type={FLOP_TYPE}
                        removeCard={removeCard}
                        setChosenCard={setChosenCard}
                        menuState
                      />
                    })}
                    {table.turn !== undefined && (
                      <Card
                        rank={table.turn.rank}
                        suit={table.turn.suit}
                        chosen={activeFieldCardType === TURN_TYPE}
                        type={TURN_TYPE}
                        menuState
                        removeCard={removeCard}
                        setChosenCard={setChosenCard}
                      />
                    )}
                    {table.river !== undefined && (
                      <Card
                        rank={table.river.rank}
                        suit={table.river.suit}
                        type={RIVER_TYPE}
                        chosen={activeFieldCardType === RIVER_TYPE}
                        menuState
                        removeCard={removeCard}
                        setChosenCard={setChosenCard}
                      />
                    )}
                  </div>
                )}
              </React.Fragment>
            </div>
          )}
          <div
            className={bem({block, elem: 'choose-main-block'})}
            style={mainChooseBlockStyle}
          >
            {menu.map((cards, index) =>
              <CardContainer
                key={index}
                cards={cards}
                addCardToBoard={addCardToBoard}
                updateActiveField={updateActiveField}
                updateActiveFieldDelay={isMobile && cardsLeftToPick === 1}
                setCardsMenu={setCardsMenu}
                isMobile={isMobile}
              />
            )}
            {isMobile && (
              <ButtonsWrapper
                click={reset}
                type={BUTTON_TYPE_GREY}
              >
                {MENU_RESET_BUTTON}
              </ButtonsWrapper>
            )}
          </div>
        </div>
      </div>
      {!isMobile && (
        <div className={bem({block, elem: 'buttons-wrapper'})}>
          <ButtonsWrapper
            click={isPOC ? calculateOdds : getWinnerHand}
            type={BUTTON_TYPE_BLUE}
          >
            {isPOC ? MENU_GET_RESULTS_BUTTON_POC : MENU_GET_RESULTS_BUTTON}
          </ButtonsWrapper>
          <ButtonsWrapper
            click={reset}
            type={BUTTON_TYPE_GREY}
          >
            {MENU_RESET_BUTTON}
          </ButtonsWrapper>
        </div>
      )}
      <div className={bem({block, elem: 'error-popup'})}>
        <Hint
          title={MENU_ERROR_HINT_TITLE}
          info={errorInfo}
          hints={hints}
          type={TYPE_HINT_ERROR}
          close={closeHint}
        />
      </div>
    </div>
  );
};

export default Menu;